export default __webpack_public_path__ + "src/_images/Tamper_Icon.svg";